import { FC, ReactNode } from 'react';
import { Stack, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { isNotNullOrUndefined } from '@vy/utils';
import { getSelectorAttribute } from '@vy/app-selectors';
import { VyPaper } from '../../../../../components/new-design/data-display/VyPaper/VyPaper';
import { AnalyticCardSkeleton } from '../../AnalyticCardLoader/AnalyticCardSkeleton';
import { VyDivider } from '../../../../../components/new-design/atoms';

type CtaButtonProps = {
  text: string;
  path: string;
};

type AnalyticCardProps = {
  title: string;
  dataVy?: string;
  ctaButtonDataVy?: string;
  ctaButtonConfig?: CtaButtonProps;
  containerSpacing?: number;
  renderAdditionalHeaderContent?: () => ReactNode;
  children: ReactNode;
  minHeight?: string;
  isLoading?: boolean;
};

export const AnalyticCard: FC<AnalyticCardProps> = ({
  title,
  dataVy,
  ctaButtonDataVy,
  ctaButtonConfig,
  children,
  containerSpacing = '20px',
  minHeight = '290px',
  renderAdditionalHeaderContent,
  isLoading,
}) => {
  return (
    <VyPaper
      {...(dataVy ? getSelectorAttribute(dataVy) : {})}
      sx={{
        padding: '16px 20px',
        borderRadius: '13px',
        height: '100%',
        boxShadow: 'none',
        border: '1px solid #DFEBF1',
        minHeight,
      }}
    >
      <Stack
        divider={<VyDivider />}
        sx={{
          height: "100%",
          gap: containerSpacing
        }}>
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap"
          }}>
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 600
            }}>
            {title}
          </Typography>
          {renderAdditionalHeaderContent?.()}
        </Stack>

        {isLoading ? (
          <AnalyticCardSkeleton />
        ) : (
          <>
            {children}

            {isNotNullOrUndefined(ctaButtonConfig) && (
              <Stack
                sx={{
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  flexGrow: 1
                }}>
                <Link to={ctaButtonConfig.path}>
                  <Button
                    variant="outlined"
                    endIcon={<ArrowForwardIosIcon sx={{ fontSize: '14px !important' }} />}
                    sx={{ border: '1px solid #A4ADBE', borderRadius: 0.5 }}
                    {...(ctaButtonDataVy ? getSelectorAttribute(ctaButtonDataVy) : {})}
                  >
                    {ctaButtonConfig.text}
                  </Button>
                </Link>
              </Stack>
            )}
          </>
        )}
      </Stack>
    </VyPaper>
  );
};
